module.exports = __webpack_public_path__ + "img/76983e60-1b8b-4a34-86d0-0101d16a9452.75b33974.png";